"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const isTablet = () => window.matchMedia('(max-width: 1024px)').matches;

var _default = isTablet;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJpc1RhYmxldCIsIndpbmRvdyIsIm1hdGNoTWVkaWEiLCJtYXRjaGVzIl0sInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWxzL2lzVGFibGV0LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImNvbnN0IGlzVGFibGV0ID0gKCkgPT4gd2luZG93Lm1hdGNoTWVkaWEoJyhtYXgtd2lkdGg6IDEwMjRweCknKS5tYXRjaGVzXG5cbmV4cG9ydCBkZWZhdWx0IGlzVGFibGV0XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQSxNQUFNQSxRQUFRLEdBQUcsTUFBTUMsTUFBTSxDQUFDQyxVQUFQLENBQWtCLHFCQUFsQixFQUF5Q0MsT0FBaEU7O2VBRWVILFEifQ==